/**
 *
 * site nav functions
 *
 */

// const params = new URLSearchParams(window.location.search)
// const pt = params.get('pt')

jQuery(function () {
  console.log("site nav js");
  console.log("-==============================");

  $(".site-nav .site-nav__link").each(function () {
    //check for duplicates
    if (
      ($(`.site-nav [href="${$(this).attr("href")}"]`).length > 1 &&
        !$(`.site-nav [href="${$(this).attr("href")}"]`)
          .parent()
          .hasClass("site-nav--has-dropdown-grandchild") &&
        !$(`.site-nav [href="${$(this).attr("href")}"]`)
          .parent()
          .hasClass("site-nav--has-dropdown")) ||
      ($(`.site-nav [href="${$(this).attr("href")}"]`).length > 2 &&
        $(`.site-nav [href="${$(this).attr("href")}"]`)
          .parent()
          .hasClass("site-nav--has-dropdown-grandchild"))
    ) {
      //assign number to duplicates
      let url = new URL(window.location.origin + $(this).attr("href"));
      if (url.searchParams.size == 0) {
        $(`.site-nav [href="${$(this).attr("href")}"]`).each(function (i) {
          url.searchParams.set("n", i);
          $(this).attr("href", url.pathname + url.search);
        });
      }
    }
  });

  let collection_link = window.location.pathname;
  let search = new URLSearchParams(window.location.search);
  let active_link = $(
    `.site-nav a[data-handle="${collection_link.split("/").pop()}"][href*="?n=${search.get("n")}"].site-nav__link`,
  ).parent();
  console.log("can find link", active_link);

  //cant find query with parameter activelink default to collection link
  if (active_link.length <= 0 && collection_link !== "/") {
    // active_link = $($(`.site-nav a[data-handle="${collection_link.split('/').pop()}"][href*="/collections"].site-nav__link`)).parent().addClass('site-nav--active')
    active_link = $(
      $(
        `.site-nav a[data-handle="${collection_link.split("/").pop()}"][href*="/collections"].site-nav__link`,
      )[0],
    ).parent();
  } else {
    //check for active link from detect
    waitForElm(".site-nav .site-nav--current", 4000).then(function () {
      active_link = $(".site-nav--current").parent();
    });
  }

  //if theres active link
  if (active_link.length > 0) {
    active_link.addClass("site-nav--active");
    active_link.addClass("site-nav--current");

    const iterateActiveNav = (index) => {
      if (index == 0) return;
      let el = $(`.site-nav [data-index=${index}]`);
      el.addClass("site-nav--active");
      iterateActiveNav(el.attr("data-parent"));
    };

    iterateActiveNav(active_link.attr("data-parent"));

    //show dropdown of active link if there is
    if (active_link.hasClass("site-nav--has-dropdown")) {
      $(`.site-nav [data-index=${active_link.attr("data-index")}0]`).addClass(
        "site-nav--active",
      );
    }

    // show thirdlevel
    $(`.site-nav .third-level .site-nav--active`)
      .parent()
      .css({ opacity: "1", display: "block", "pointer-events": "auto" });
  }

  //third level display
  $(".site-nav .second-level li a").click(function () {
    $(".site-nav .third-level").css({
      opacity: "0",
      display: "none",
      "pointer-events": "none",
    });
    $(".site-nav .second-level li a").removeClass("selected-nav");
    let data_index = $(this).parent().attr("data-index");
    $(this).addClass("selected-nav");
    $(`.site-nav .third-level[data-parent=${data_index}]`).css({
      opacity: "1",
      display: "block",
      "pointer-events": "auto",
    });
  });

  //bold text
  $(".site-nav .site-nav__link").each(function () {
    var text = $(this).html();
    text = text.replace("WisBlock", "<strong>WisBlock</strong>");
    $(this).html(text);
  });

  /**
   *
   * menu dark over lay start
   *
   */

  $(".site-nav .dropdown-parent").click(function (e) {
    e.preventDefault();
  });
  $("header").click(function (e) {
    let heads = e.target;
    let finds = false;
    if ($(".site-nav").find(heads).length > 0) {
      finds = true;
    }
    if (!finds) {
      hideMenu();
    }
  });

  $(".site-nav .site-dark-overlay").click(function () {
    hideMenu();
  });

  $(".site-nav.first-level > li > a").click(function (e) {
    e.stopPropagation();
    // $('.site-nav--has-dropdown .site-nav__link .icon-arrow-down').css({'transform':'rotate(0deg)'})
    if (
      !$(this).parent().find(".second-level_dropdown-container").is(":visible")
    ) {
      hideMenu();
      // $(this).parent().find('.site-nav__link .icon-arrow-down').css({'transform':'rotate(180deg)'})
      $(this)
        .parent()
        .find(".second-level_dropdown-container")
        .css({ display: "flex" });
      $(this)
        .parent()
        .find(".second-level")
        .css({ opacity: "1", "pointer-events": "auto" });
      $(".site-nav .site-dark-overlay").css({ display: "block" });
    } else {
      $(this)
        .parent()
        .find(".site-nav__link .icon-arrow-down")
        .css({ transform: "rotate(0deg)" });
      hideMenu();
    }
  });

  function hideMenu() {
    $(".site-nav .second-level_dropdown-container").css({ display: "none" });
    $(".site-nav .second-level").css({
      opacity: "0",
      "pointer-events": "none",
    });
    $(".site-nav .site-dark-overlay").css({ display: "none" });
  }
});
